const envBaseUrl = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
const envAiBaseUrl = (process.env.REACT_APP_AI_URL || '').replace(/\/$/, '');

function resolveApiBaseUrl() {
  if (envBaseUrl) {
    return envBaseUrl;
  }

  // When frontend is served directly on localhost:3000, send API calls to backend:8000.
  if (typeof window !== 'undefined') {
    const { hostname, port } = window.location;
    const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
    if (isLocalhost && port === '3000') {
      return 'http://localhost:8000';
    }
  }

  // Default to same-origin (works behind nginx reverse proxy).
  return '';
}

export const API_BASE_URL = resolveApiBaseUrl();

function resolveAiBaseUrl() {
  if (envAiBaseUrl) {
    return envAiBaseUrl;
  }

  if (typeof window !== 'undefined') {
    const { hostname, port } = window.location;
    const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
    if (isLocalhost && port === '3000') {
      // Local dev runs AI service on :8200 while backend API remains on :8000.
      return 'http://localhost:8200';
    }
  }

  // In docker/nginx deployments, same-origin routing handles /ai/*.
  return envBaseUrl || '';
}

export const AI_BASE_URL = resolveAiBaseUrl();
